export default "__VITE_ASSET__BKWOXTfL__"